(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["goodform-email-signup"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('goodform-email-signup')) {
    customElements.define('goodform-email-signup', class extends HTMLElement {
      connectedCallback() {
        this.closeSignup = () => {
          this.hidden = true;
          try { sessionStorage.setItem('gf-signup-dismissed', '1'); } catch {}
        };
        this.querySelector('.gf-signup__close')?.addEventListener('click', this.closeSignup);
        this.onKey = event => { if (event.key === 'Escape') this.closeSignup(); };
        if (this.dataset.mode !== 'popup') return;
        this.addEventListener('keydown', this.onKey);
        this.timer = setTimeout(() => {
          let dismissed = false;
          try { dismissed = sessionStorage.getItem('gf-signup-dismissed') === '1'; } catch {}
          const subscribed = document.querySelector('.gf-signup__success');
          if (!dismissed && !subscribed && matchMedia('(min-width: 750px)').matches && !document.querySelector('dialog[open]')) this.hidden = false;
        }, 10000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.querySelector('.gf-signup__close')?.removeEventListener('click', this.closeSignup);
        this.removeEventListener('keydown', this.onKey);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
